// extracted by mini-css-extract-plugin
export default {"loaderContainer":"EstimationLoader_loaderContainer__7uGab","loader":"EstimationLoader_loader__bqfXJ"};